import React from 'react';
import { Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

export default function PostTextDisplay({ _post }) {
  const mentionRegex = /@[\w\s]+/g;
  const urlRegex =
    /((?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/\S*)?)/g;

  const combinedRegex = new RegExp(`${mentionRegex.source}|${urlRegex.source}`, 'gi');
  const navigate = useNavigate();

  const renderTextWithNameLink = (text, mentions = []) => {
    if (!mentions?.length) return text;

    // Build a regex to match all tags, escaping special characters
    const tagRegex = new RegExp(
      `(${mentions?.map((tagObj) => tagObj.tag.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')).join('|')})`,
      'g',
    );

    const parts = text.split(tagRegex);

    return parts.map((part, idx) => {
      const tagObj = mentions?.find((tagObj) => tagObj.tag === part);
      if (tagObj) {
        return (
          <a
            key={idx}
            style={{ color: '#3182ce', textDecoration: 'underline' }}
            onClick={(e) => {
              e.stopPropagation();
              navigate(
                `../view-user?userid=${tagObj.id}&usertype=${tagObj.user_type_id}`,
              );
            }}
          >
            {tagObj.tag}
          </a>
        );
      }
      return part;
    });
  };


  

  const renderTextWithMentions = (text) => {
    const mentions = (_post?.mentions || []).map((user) => ({
      ...user,
      tag: `@${user?.first_name} ${user?.last_name}`,
    }));
  
    const tagRegex = new RegExp(
      `(${mentions
        .map((tagObj) =>
          tagObj.tag.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
        )
        .join('|')})`,
      'g'
    );
    const parts = text.split(tagRegex);

    return parts.map((part, idx) => {
      const tagObj = mentions.find((tag) => tag.tag === part);
      if (tagObj) {
        return (
          <a
            key={idx}
            className="text-blue-500"
            onClick={(e) => {
              e.stopPropagation();
              navigate(
                `../view-user?userid=${tagObj.id}&usertype=${tagObj.user_type_id}`
              );
            }}
          >
            {tagObj.tag}
          </a>
        );
      }
      return <React.Fragment key={idx}>{part}</React.Fragment>;
    });
  };

  return (
    <Text className="mt-5 w-full" color="#000">
      {_post?.text.split('\n\n').map((paragraph, paraIndex) => {
      const elements = [];
      let lastIndex = 0;

      for (const match of paragraph.matchAll(combinedRegex)) {
        const matchText = match[0];
        const index = match.index;

        // Push the text before the match
        if (lastIndex < index) {
          elements.push(
            <React.Fragment key={`${paraIndex}-text-${lastIndex}`}>
              {renderTextWithNameLink(paragraph.slice(lastIndex, index))}
            </React.Fragment>
          );
        }

        // Check if it's a URL or a mention
        if (matchText.match(urlRegex)) {
          const href = matchText.startsWith('http') ? matchText : `https://${matchText}`;
          elements.push(
            <a
              key={`${paraIndex}-url-${index}`}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
              onClick={(e) => e.stopPropagation()}
            >
              {matchText}
            </a>
          );
        } else if (matchText.match(mentionRegex)) {
          elements.push(
            <React.Fragment key={`${paraIndex}-mention-${index}`}>
              {renderTextWithMentions(matchText)}
            </React.Fragment>
          );
        }

        lastIndex = index + matchText.length;
      }

      // Push the remaining text
      if (lastIndex < paragraph.length) {
        elements.push(
          <React.Fragment key={`${paraIndex}-last`}>
            {renderTextWithMentions(paragraph.slice(lastIndex))}
          </React.Fragment>
        );
      }

      return (
        <span key={paraIndex}>
          {elements}
          <br />
        </span>
      );
    })}

    </Text>
  );
}
